import addressAPI from '../../api/Address'
import * as types from '../mutation-types'
import {http} from "../../api/__http";

// initial state
const state = {
}

// getters
const getters = {
}

// actions
const actions = {
    getStreet({ commit } , params) {
        return new Promise(resolve => {
            addressAPI.getStreet(street => {
                resolve(street)
            }, params)
        });
    }
}

// mutations
const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Address.js